module.exports = function() {
  return new Worker(__webpack_public_path__ + "tree_worker.24ad56ad.worker.js");
};